import React from 'react';

import LogInForm from './components/LogInForm';

export default class AuthPage extends React.Component {
  componentDidMount() {
    document.title="Sign In | Milkyweb";
  };

  render() {
    return (
      <div>
        <LogInForm style={{ margin: '50px auto 0 auto' }} />
      </div>
    );
  }
}